import { LoadingSpinner } from '@ctw/shared/components/loading-spinner';
import type { DocumentViewer as EagerDocumentViewer } from '@ctw/shared/content/document-viewer/document-viewer';
import { type ComponentProps, lazy, Suspense } from 'react';

type DocumentViewerProps = ComponentProps<typeof EagerDocumentViewer>;

// The viewer pulls in the PDF renderer, so it loads on first open rather than with every
// bundle that registers the modal actions.
const DocumentViewer = lazy<typeof EagerDocumentViewer>(async () => ({
  default: (await import('@ctw/shared/content/document-viewer/document-viewer')).DocumentViewer,
}));

export const LazyDocumentViewer = (props: DocumentViewerProps) => (
  <Suspense fallback={<LoadingSpinner centered={true} />}>
    <DocumentViewer {...props} />
  </Suspense>
);
